const TailoredActionName = {
    /**
     * Unknown
     */
    Unknown: 'TXPUnknown',

    /**
     * View email action
     */
    ViewEmail: 'TXPViewEmail',

    /**
     * View calendar action
     */
    ViewCalendar: 'TXPViewCalendar',

    /**
     * Navigate to calendar action
     */
    NavToCalendar: 'TXPNavToCalendar',

    /**
     * Add to calendar action
     */
    AddToCalendar: 'TXPAddToCalendar',

    /**
     * Expand card action
     */
    ExpandCard: 'TXPExpandCard',

    /**
     * Settings action
     */
    Settings: 'TXPSettings',

    /**
     * Useful feedback action
     */
    FeedbackPositive: 'TXPFeedbackPositive',

    /**
     * Not useful feedback action
     */
    FeedbackNegative: 'TXPFeedbackNegative',

    /**
     * Feedback action reported when user clicks 'Give us feedback'
     */
    Feedback: 'TXPFeedback',

    /**
     * Feedback action reported when user clicks the feedback link in the context menu
     */
    FeedbackContextMenu: 'TXPFeedbackContextMenu',

    /**
     * Share event action
     */
    ShareEvent: 'TXPShareEvent',

    /**
     * Report an issue action
     */
    ReportAnIssue: 'TXPReportAnIssue',

    /**
     * Report an issue action due to TEE triggered donation request
     */
    TeeTriggeredDonation: 'TXPTeeTriggeredDonation',

    /**
     * Send feedback to Outlook action
     */
    SendFeedbackToOutlook: 'TXPSendFeedbackToOutlook',

    /**
     * Gets the status of the parcel's delivery
     */
    GetParcelDeliveryStatus: 'TXPGetParcelDeliveryStatus',

    /**
     * Remove from calendar
     */
    RemoveFromCalendar: 'TXPRemoveFromCalendar',

    /**
     * Txp control is loaded in mail
     */
    LoadTxPMail: 'TXPLoadMail',

    /**
     * Fires when a TXP card is viewed
     */
    CardViewed: 'TxpCardViewed',

    /**
     * Fires when the disclaimer link is clicked
     */
    DisclaimerViewed: 'TxpDisclaimerViewed',
};

export default TailoredActionName;
